/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CodeFromServer from './CodeFromServer';
import ImageInputComponent from './ImageInputComponent';
import VideoInputComponent from './VideoInputComponent';


const YoutubeUploader = ({
  id,
  InputComponent,
  setFieldValue,
  setFieldError,
  value,
  campaignId,
  editMode,
  setUploading,
  type,
}) => {
  const [uploading, setLocalUploading] = useState(false);

  const reset = () => {
    setFieldValue('');
    setLocalUploading(false);
    setUploading(false);
  };

  if (!value) {
    return (
      <InputComponent
        uploading={uploading}
        setUploading={(isUploading) => {
          setLocalUploading(isUploading);
          setUploading(isUploading); 
        }}
        setFieldValue={setFieldValue}
        setFieldError={setFieldError}
        reset={reset}
        campaignId={campaignId}
        id={id}
        editMode={editMode}
      />
    );
  }

  return <CodeFromServer value={value} reset={reset} type={type} />;
};


YoutubeUploader.defaultProps = {
  campaignId: null,
  value: null,
};

YoutubeUploader.propTypes = {
  InputComponent: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  value: PropTypes.string,
  campaignId: PropTypes.string,
  id: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
};

export const ImageYoutubeUploader = props =>
  <YoutubeUploader InputComponent={ImageInputComponent} type="Image" {...props} />;

export const VideoUploader = props =>
  <YoutubeUploader InputComponent={VideoInputComponent} type="Video" {...props} />;
